"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.get = void 0;
// simple dependency injector for easy test
const instancesPool = {};
const lazyInstancesFactory = {
    ActivityService: () => new (require('../Activity/ActivityService')).default(),
    Authorization: () => new (require('../Authorization/Authorization')).default(),
    CarouselBanner: () => new (require('../CarouselBanner/CarouselBanner')).default(),
    Database: () => new (require('../Database/Database')).default(),
    Device: () => new (require('../Device/Device')).default(),
    Enquire: () => new (require('../Enquire/Enquire')).default(),
    NewsPage: () => new (require('../News/NewsPage')).default(),
    PaymentService: () => new (require('../Payment/PaymentService')).default(),
    RepairOrder: () => new (require('../RepairOrder/RepairOrder')).default(),
    SelectedArticle: () => new (require('../SelectedArticle/SelectedArticle')).default(),
    Services: () => new (require('../Services/Services')).default(),
    Quotation: () => new (require('../Quotation/Quotation')).default(),
    StatisticService: () => new (require('../Statistic/StatisticService')).default(),
};
const get = (name) => {
    if (name in instancesPool) {
        return instancesPool[name];
    }
    if (!(name in lazyInstancesFactory)) {
        throw new Error('Instance not set');
    }
    const instance = lazyInstancesFactory[name]();
    instancesPool[name] = instance;
    return instance;
};
exports.get = get;
const set = (name, instance) => {
    instancesPool[name] = instance;
    return instance;
};
exports.set = set;
//# sourceMappingURL=ComponentRegister.js.map